import { useInternalPortalAuthProvider } from "../provider/internal-auth-provider.hook";
import "./Login.scss";

export const Login = () => {
  // Call the hook once for each provider to generate a specific URL for each.
  const microsoftAuth = useInternalPortalAuthProvider("pcg-import-hub");
  const googleAuth = useInternalPortalAuthProvider("pcg-google-sso");

  return (
    <div>
      <div className="login-container">
        <h1 className="login-title">Hi there</h1>
        <p className="login-subtitle">Please sign in with your company account.</p>
        <div className="login-btn-container">
          <a
            href={microsoftAuth.ssoLoginUrl}
            className="button is-link is-outlined"
          >
            Sign In with Microsoft SSO
          </a>

          <a
            href={googleAuth.ssoLoginUrl}
            className="button is-link is-outlined"
          >
            Sign In with Google SSO
          </a>
        </div>
      </div>
    </div>
  );
};